const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost';

export async function PostEmpresa(empresa: any) {
    try {
        const response = await fetch(`${baseUrl}:8061/metadata/empresas`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify(empresa)
        });
        return response.ok;
    } catch (error) {
        console.error('Error posting empresa:', error);
        return false;
    }
}

export async function PutEmpresa(empresa: any) {
    try {
        const response = await fetch(`${baseUrl}:8061/metadata/empresas`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify(empresa)
        });
        return response.ok;
    } catch (error) {
        console.error('Error updating empresa:', error);
        return false;
    }
}

export async function DeleteEmpresa(id: number) {
    try {
        const response = await fetch(`${baseUrl}:8061/metadata/empresas/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
        });
        return response.ok;
    } catch (error) {
        console.error('Error deleting empresa:', error);
        return false;
    }
}
